import '../CsvJsonInfoPages.scss';


function SMR() {

   const data = [
    { field: 1, description: 'CAP Vehicle Code' },
    { field: 2, description: 'CAP Vehicle Identification Number' },
    { field: 3, description: 'Filler' },
    { field: 4, description: 'Mileage/Kms 1' },
    { field: 5, description: 'Periods 1st Mileage/Kms Values' },
    { field: 6, description: 'Mileage/Kms 2' },
    { field: 7, description: 'Periods 2nd Mileage/Kms Values' },
    { field: 8, description: 'Mileage/Kms 3' },
    { field: 9, description: 'Periods 3rd Mileage/Kms Values' },
    { field: 10, description: 'Mileage/Kms 4' },
    { field: 11, description: 'Periods 4th Mileage/Kms Values' },
    { field: 12, description: 'Mileage/Kms 5' },
    { field: 13, description: 'Periods 5th Mileage/Kms Values' },
    { field: 14, description: 'Mileage/Kms 6' },
    { field: 15, description: 'Periods 6th Mileage/Kms Values' },
    { field: 16, description: 'Mileage/Kms 7' },
    { field: 17, description: 'Periods 7th Mileage/Kms Values' },
    { field: 18, description: 'Mileage/Kms 8' },
    { field: 19, description: 'Periods 8th Mileage/Kms Values' },
    { field: 20, description: 'Mileage/Kms 9' },
    { field: 21, description: 'Periods 9th Mileage/Kms Values' },
    { field: 22, description: 'Mileage/Kms 10' },
    { field: 23, description: 'Periods 10th Mileage/Kms Values' },
    { field: 24, description: 'Mileage/Kms 11' },
    { field: 25, description: 'Periods 11th Mileage/Kms Values' },
    { field: 26, description: 'Mileage/Kms 12' },
    { field: 27, description: 'Periods 12th Mileage/Kms Values' },
    { field: 28, description: 'Mileage/Kms 13' },
    { field: 29, description: 'Periods 13th Mileage/Kms Values' },
    { field: 30, description: 'Mileage/Kms 14' },
    { field: 31, description: 'Periods 14th Mileage/Kms Values' },
    { field: 32, description: 'Mileage/Kms 15' },
    { field: 33, description: 'Periods 15th Mileage/Kms Values' },
    { field: 34, description: 'Mileage/Kms 16' },
    { field: 35, description: 'Periods 16th Mileage/Kms Values' },
    { field: 36, description: 'Mileage/Kms 17' },
    { field: 37, description: 'Periods 17th Mileage/Kms Values' },
    { field: 38, description: 'Mileage/Kms 18' },
    { field: 39, description: 'Periods 18th Mileage/Kms Values' },
    { field: 40, description: 'Mileage/Kms 19' },
    { field: 41, description: 'Periods 19th Mileage/Kms Values' },
    { field: 42, description: 'Mileage/Kms 20' },
    { field: 43, description: 'Periods 20th Mileage/Kms Values' },
    { field: 44, description: 'Mileage/Kms 21' },
    { field: 45, description: 'Periods 21st Mileage/Kms Values' },
    { field: 46, description: 'Mileage/Kms 22' },
    { field: 47, description: 'Periods 22nd Mileage/Kms Values' },
    { field: 48, description: 'Mileage/Kms 23' },
    { field: 49, description: 'Periods 23rd Mileage/Kms Values' },
    { field: 50, description: 'Mileage/Kms 24' },
    { field: 51, description: 'Periods 24th Mileage/Kms Values' },
    { field: 52, description: 'Mileage/Kms 25' },
    { field: 53, description: 'Periods 25th Mileage/Kms Values' },
    { field: 54, description: 'Mileage/Kms 26' },
    { field: 55, description: 'Periods 26th Mileage/Kms Values' },
    { field: 56, description: 'Mileage/Kms 27' },
    { field: 57, description: 'Periods 27th Mileage/Kms Values' },
    { field: 58, description: 'Mileage/Kms 28' },
    { field: 59, description: 'Periods 28th Mileage/Kms Values' },
    { field: 60, description: 'Mileage/Kms 29' },
    { field: 61, description: 'Periods 29th Mileage/Kms Values' },
    { field: 62, description: 'Mileage/Kms 30' },
    { field: 63, description: 'Periods 30th Mileage/Kms Values' },
    { field: 64, description: 'Current Vehicle Flag.' },
  ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>Future Values - SMR</h1>
            <p>Provides Service, maintenance and Repair costs for vehicles broken down into Brake, Tyre, Service and Other costs.
                <b>File Naming Convention</b>
                The &lt;FILENAME&gt; is dependant on the product being produced as follows
            </p>

            <b>Cars</b>
            <p>CBrake.??? Car Brake Costs<br />
                CTyre.??? Car Tyre Costs<br />
                CService.??? Car Service Costs<br />
                COther.??? Car Other Costs<br />
                CTotal.??? Car Total Costs
            </p>

            <b>Light Commercials</b>
            <p>LBrake.??? Light Commercial Brake Costs<br />
                LTyre.??? Light Commercial Tyre Costs<br />
                LService.??? Light Commercial Service Costs<br />
                LOther.??? Light Commercial Other Costs<br />
                LTotal.??? Light Commercial Total Costs<br /><br />

                The 3 question marks (???) on each of the above files will be replaced with the month i.e. MAR for March.<br/><br/>
                Each subsequent record contains 5352 bytes of data and is terminated by CR/LF characters.<br/>

                The 10 Periods Covered 6, 12, 18, 24, 30, 36, 42, 48, 54 and 60 Months.<br/><br/>

                NOTE : Not all of the periods may be used.
            </p>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
}

export default SMR;
